// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import ElementUI from 'element-ui';
import 'animate.css';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import wow from 'wowjs'
import "wowjs/css/libs/animate.css"
import 'vant/lib/index.css';
import VueCaptcha from 'vue-captcha'
import { Popup,Button  } from 'vant';
Vue.prototype.$wow = wow
Vue.use(ElementUI);
Vue.use(Popup);
Vue.use(Button);
Vue.prototype.$imgUrl = 'http://www.bslmedu.com'//上传

//瀑布流
import waterfall from 'vue-waterfall2'
Vue.use(waterfall)
// 图片验证码
Vue.use(VueCaptcha)
//pc手机切换
if (isMobile()) {
    // window.open('http://www.bslmedu.com/con','_self')
    router.push('/mobileIndex');
} else {
    router.push('/');
}
function isMobile(){
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag;
}
// router.onError((error) => {
//   const pattern = /Loading chunk (\d)+ failed/g;
//   const isChunkLoadFailed = error.message.match(pattern);
//   const targetPath = router.history.pending.fullPath;
//   console.log(targetPath, '那个错误抓取！！！')
//   if (isChunkLoadFailed) {
//     router.replace(targetPath);
//   }
// })
Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'printReportShowQuery') {
    // 创建一个StorageEvent事件
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (k, val) {
        localStorage.setItem(k, val);
        // 初始化创建的事件
        newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
        // 派发对象
        window.dispatchEvent(newStorageEvent)
      }
    }
    return storage.setItem(key, newVal);
  }
}
router.afterEach( ( to, from, next ) => {
  setTimeout(()=>{
    if (to.path !== '/recruit' && to.path !== '/zxns' && to.path !== '/jobDetails' && to.path !== '/deliveryRecord' && to.path.indexOf('workbench') == -1 && !isMobile()) {
      var _hmt = _hmt || [];
      ( function () {
      //每次执行前，先移除上次插入的代码
      document.getElementById( 'baidu_tj' ) && document.getElementById( 'baidu_tj' ).remove();
      var hm = document.createElement( "script" );
      var analytics_pw = 'c1c002a211d1602571f56b5475b77c9b'
      hm.src = ['ht','t','ps',':/','/h','m','.','ba','i','d','u.c','o','m/','h','m','.j','s?',analytics_pw].join('')
      hm.id = "baidu_tj"
      var s = document.getElementsByTagName( "script" )[0];
      s.parentNode.insertBefore(hm, s);
      })();
    } else {
      if (from.path !== '/' && !isMobile()) {
        window.location.reload()
      }
    }
  },0);
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js